import { forwardRef } from 'react';
import { SvgClose } from '../../../icons';
import { classes } from '../../../utils/commonUtils';
import { ActionButton } from './action-button/action-button';

import css from './details-button.module.scss';

interface DetailsCloseButtonProps {
  onClick: () => void;
  className?: string;
}
export const DetailsCloseButton = forwardRef<HTMLButtonElement, DetailsCloseButtonProps>(
  ({ onClick, className }, ref) => {
    return (
      <ActionButton variant="ghost" className={classes(css.close, className)} onClick={onClick} ref={ref}>
        <SvgClose />
      </ActionButton>
    );
  },
);
